module.exports = __webpack_public_path__ + "static/media/logo_nav.a32a3167.png";